import React from 'react'
import Button from './Button'

const ButtonDelete = (props) => {
  return (
    <Button
      icon="Delete"
      title="Supprimer"
      {...props}
    />
  )
}

export default ButtonDelete
